const defaultState = () => {
	return {
		riskCategoryList: null,
      riskStatusList: null,
      riskTreatmentList: null,
		inherentProbabilityList: null,
      inherentImpactList: null,
      inherentRiskRatingList: null,
      residualProbabilityList: null,
      residualImpactList: null,
      residualRiskRatingList: null,
		riskOwnerList: null,
		riskCreatorList: null,
      controlMitigationEffectivenessList: null,
      controlMitigationFocusList: null,
      riskClosureReasonList: null,
	}
}

const state = () => ({
	riskCategoryList: null,
   riskStatusList: null,
   riskTreatmentList: null,
   inherentProbabilityList: null,
   inherentImpactList: null,
   inherentRiskRatingList: null,
   residualProbabilityList: null,
   residualImpactList: null,
   residualRiskRatingList: null,
   riskOwnerList: null,
	riskCreatorList: null,
   controlMitigationEffectivenessList: null,
   controlMitigationFocusList: null,
   riskClosureReasonList: null,
});

const getters = {}

const actions = {
   resetState({ commit }) {
      commit("resetState")
   },
};

const mutations = {
   resetState(state) {
      Object.assign(state, defaultState());
   },
   setRiskCategoryList(state, list) {
      state.riskCategoryList = list;
   },
   setRiskStatusList(state, list) {
      state.riskStatusList = list;
   },
   setRiskTreatmentList(state, list) {
      state.riskTreatmentList = list;
   },
   setInherentProbabilityList(state, list) {
      state.inherentProbabilityList = list;
   },
   setInherentImpactList(state, list) {
      state.inherentImpactList = list;
   },
   setInherentRiskRatingList(state, list) {
      state.inherentRiskRatingList = list;
   },
   setResidualProbabilityList(state, list) {
      state.residualProbabilityList = list;
   },
   setResidualImpactList(state, list) {
      state.residualImpactList = list;
   },
   setResidualRiskRatingList(state, list) {
      state.residualRiskRatingList = list;
   },
   setRiskOwnerList(state, list) {
      state.riskOwnerList = list;
   },
   setRiskCreatorList(state, list) {
      state.riskCreatorList = list;
   },
   setControlMitigationEffectivenessList(state, list) {
      state.controlMitigationEffectivenessList = list;
   },
   setControlMitigationFocusList(state, list) {
      state.controlMitigationFocusList = list;
   },
   setRiskClosureReasonList(state, list) {
      state.riskClosureReasonList = list;
   },
};

export default {
   name: "risk",
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};